import styled from 'styled-components';

const OverlayStyled = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
`

const Overlay = ({ src, alt }) => {
  return <OverlayStyled src={src} alt={alt}/>;
}

export default Overlay;